import { getApiBaseUrl } from '../utils/apiBaseUrl'

export interface AllAddressesData {
  id: number;
  addressLine1: string | null;
  addressLine2: string | null;
  addressLine3: string | null;
  addressType: string | null;
  pinCode: string | null;
  blockCode: string | null;
  addressCode: string | null;
  latitude: string | null;
  longitude: string | null;
  userId: number | null;
  userName: string | null;
  isFavourite: boolean;
  isPrivate: boolean | null;
  createdDate: string | null; 
  digiPin: string | null;
}

export interface GetAddressesResponse {
  totalRecords: number;
  pageNumber: number;
  pageSize: number;
  data: AllAddressesData[];
}

export const GetAllAddressesAsync = async (
  pageNumber: number,
  pageSize: number,
  token: string
): Promise<GetAddressesResponse> => {
  const baseUrl = getApiBaseUrl();
  const apiUrl = `${baseUrl}/api/Admin/GetAllAddressesAsync?pageNumber=${pageNumber}&pageSize=${pageSize}`;

  try {
    const response = await fetch(apiUrl, {
      method: 'GET',
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json'
      }
    });

    if (!response.ok) {
      throw new Error(`Failed to fetch referral details`);
    }

    return await response.json();
  } catch (error) {
    console.error('Error in GetAllAddressesAsync:', error);
    throw error;
  }
};
